module.exports = __webpack_public_path__ + "img/angie-thomas.51b6b6f3.png";